<template>
  <v-dialog
    v-model="show"
    :max-width="maxWidth"
    @keydown="escapeClose"
    :persistent="persistent"
    :scrollable="!!maxHeight"
  >
    <v-card :class="['pl-dialog', wrapClass]" class="pl-modal">
      <v-card-title class="pl-dialog__title">
        <slot name="header"> </slot>
      </v-card-title>
      <v-card-text :max-height="maxHeight" class="pl-modal__content">
        <slot name="content"> </slot>
      </v-card-text>
      <v-card-actions class="pl-dialog__footer" v-if="!buttonAlignRight">
        <slot name="footer"> </slot>
      </v-card-actions>
      <v-card-actions class="pl-dialog__footer" v-if="buttonAlignRight">
        <v-layout slot="footer" align-center justify-end row fill-height>
          <slot name="footer"> </slot>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PLModal',
  model: {
    prop: 'visible',
    event: 'close',
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    maxWidth: {
      type: String,
      default: '300px',
    },
    maxHeight: {
      type: String,
      required: false,
    },
    wrapClass: {
      type: String,
      default: '',
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonAlignRight: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    escapeClose(e) {
      const ESC_KEYKODE = 27
      if (e.keyCode == ESC_KEYKODE) {
        this.show = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pl-modal {
  &__content {
    overflow-y: auto;
    max-height: 74vh;
  }
}
</style>
